
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M15.887 2l-1.323 1.322-.024.026h.051l2.06 2.06v.053l.027-.026L18 4.114 15.887 2zM5.684 14.343v-1.951l1.952 1.951H5.684zm1.283-3.422l7.573-7.573H2.978A.977.977 0 002 4.325V18h13.676c.54 0 .977-.437.977-.977V5.461L9.08 13.033 6.967 10.92z"}})])
          )
        }
      }
    